<div *ngIf="aditivos; else semAditivo">
    <div class="card bg-light" *ngFor="let aditivo of aditivos;">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-2 col-12">
                    <h6 class="mb-0">Protocolo</h6>
                    <p>{{aditivo?.protocolo   | date: 'dd/MM/yyyy'}}</p>
                </div>
                <div class="col-sm-2 col-12">
                    <h6 class="mb-0">Situação</h6>
                    <p>{{aditivo?.situacaoInterna}}</p>
                </div>
                <div class="col-sm-2 col-12">
                    <h6 class="mb-0">Aprovação</h6>
                    <p>{{aditivo?.aprovacao  | date: 'dd/MM/yyyy'}}</p>
                </div>
                <div class="col-sm-2 col-12">
                    <h6 class="mb-0">Tipo</h6>
                    <p>{{aditivo?.tipo == 'A' ? 'ADITIVO' : aditivo?.tipo   }}</p>
                </div>
            </div>
            <div class="row" *ngIf="aditivo?.comentario.length > 0">
                <div class="col-sm-12 col-12" style="text-align: justify;">
                    <h6 class="mb-0">Solicitação</h6>
                    <textarea disabled rows="30" class="form-control">{{aditivo?.comentario}}</textarea>
                </div>
            </div>
            <!-- <div class="row pt-3" *ngIf="aditivo?.comentarioAnalise && isExibirComentarioAnaliseAditivo">
                <div class="col-sm-12 col-12" style="text-align: justify;">
                    <h6 class="mb-0">Comentario da Análise do Aditivo</h6>
                    <textarea disabled rows="10" class="form-control">{{aditivo?.comentarioAnalise}}</textarea>
                </div>
            </div> -->

            <div class="card mt-3" *ngIf="aditivo.comentarioAnalise && aditivo.comentarioAnalise.length > 0 && isExibirComentarioAnaliseAditivo">
                <div class="card-header">
                    <div class="row">
                        <div class="col-sm-8 col-12">
                            <h6 class="mb-0">Comentario da Análise do Aditivo</h6>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div *ngFor="let aviso of aditivo.comentarioAnalise">
                        <textarea disabled rows="5" class="form-control h-auto">{{aviso.mensagem}}</textarea>
                    </div>
                </div>
            </div>
            
            <div class="card mt-3" *ngIf="aditivo.avisosFluxoAprovacao">
                <div class="card-header">
                    <div class="row">
                        <div class="col-sm-8 col-12 ps-10 pe-5">
                            <h6 class="mb-0">Comentários do Fluxo de Aprovação do Aditivo</h6>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="card ps-3 pt-3 pe-3" *ngIf="aditivo.avisosFluxoAprovacao && aditivo.avisosFluxoAprovacao.length > 0 ; else semAvisosFluxoAprovacao">
                        <div class="table-responsive">
                            <table class="table table-hover table-sm">
                                <thead>
                                    <tr>
                                        <th scope="col">Data</th>
                                        <th scope="col">Usuario</th>
                                        <th scope="col">Tipo Aviso</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-template ngFor let-aviso [ngForOf]="aditivo.avisosFluxoAprovacao">
                                    <!--tr *ngFor="let aviso of aditivo.avisosFluxoAprovacao" -->
                                        <tr>
                                            <td>{{aviso?.data | date:'dd/MM/yyyy HH:mm'}}</td>
                                            <td>{{aviso?.usuario}}</td>
                                            <td>{{aviso?.nomeTipoAviso}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">{{aviso?.mensagem}}</td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-3" *ngIf="exibirHistorico && isExibirComentarioAnaliseAditivo">
                <div class="card-header">
                    <div class="row">
                        <div class="col-sm-8 col-12 ps-10 pe-5">
                            <h6 class="mb-0">Informações sobre o Histórico do Aditivo</h6>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="card ps-3 pt-3 pe-3" *ngIf="aditivo.historico; else semHistorico">
                        <div class="table-responsive">
                            <table class="table table-hover table-sm">
                                <thead>
                                    <tr>
                                        <th scope="col">Data</th>
                                        <th scope="col">Evento</th>
                                        <th scope="col">Responsável</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let h of aditivo.historico">
                                        <td>{{h.dataEvento | date: 'dd/MM/yyyy'}}</td>
                                        <td>{{h.evento}}</td>
                                        <td>{{h.responsavel}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #semAditivo>
    <div >
        <h5>Não existe aditivo para operação</h5>
    </div>
</ng-template>
<ng-template #semAvisosFluxoAprovacao>
    <div >
        <h5>O Aditivo não possui comentários do fluxo de analise</h5>
    </div>
</ng-template>
<ng-template #semHistorico>
    <div >
        <h5>O Aditivo não possui histórico</h5>
    </div>
</ng-template>
